import { NOTIFICATION_TYPES } from '@/lib/consts.js'

export const PUSH_TYPES = {
  DEFAULT: 'DEFAULT',
  ITERABLE: 'ITERABLE',
}

export const PUSH_REDIRECT_ROUTES = {
  DEFAULT: 'default', // action >> reload business and execute defaultRedirect
  CALENDAR: 'calendar', // action >> redirect to calendar and execute notificationAction
}

export const PUSH_REDIRECTS = {
  [NOTIFICATION_TYPES.BOOKING]: PUSH_REDIRECT_ROUTES.CALENDAR,
  [NOTIFICATION_TYPES.AGENDA]: PUSH_REDIRECT_ROUTES.CALENDAR,
  [NOTIFICATION_TYPES.CALENDAR]: PUSH_REDIRECT_ROUTES.CALENDAR,
  [NOTIFICATION_TYPES.TRIAL_END]: PUSH_REDIRECT_ROUTES.DEFAULT,
  [NOTIFICATION_TYPES.TRIAL_END_BLOCKED]: PUSH_REDIRECT_ROUTES.DEFAULT,
}
